import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";
import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getActivities, getActivity } from "./api";

export const queries = createQueryKeys("userEvents", {
  list: ({
    queryBuilder,
  }: {
    queryBuilder?: QueryBuilder<Record<string, string> | undefined>;
  }) => ({
    queryKey: ["userEvents", queryBuilder?.toArray()],
    queryFn: () => getActivities({ queryBuilder }),
  }),
  detail: (id: number | string) => ({
    queryKey: [id],
    queryFn: () => getActivity(id),
  }),
});
